import { makeQuery } from '../types';

type Output = {getNumberOfNonAppliedCouponCodes: number };

export const getNumberOfNonAppliedCouponCodes = makeQuery<Output>(`
query GetNumberOfNonAppliedCouponCodes {
  ayn {
    getNumberOfNonAppliedCouponCodes
  }
}
`);
